import util from '@/libs/util.js'
// import { AccountLogin } from '@api/sys.login'

export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param username {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    // login ({ dispatch }, { vm, username, password }) {
    async login ({
      dispatch
    }, user) {
      // util.cookies.set('uuid', res.id)
      util.cookies.set('token', user.token)
      // 设置 vuex 用户信息
      await dispatch('d2admin/user/set', user, { root: true })
      // 用户登录后从持久化数据加载一系列的设置
      await dispatch('load')
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    async logout ({
      commit,
      dispatch
    }) {
      commit('d2admin/gray/set', false, { root: true })
      /**
       * @description 注销
       */
      // 删除cookie
      util.cookies.remove('token')
      // util.cookies.remove('uuid')
      await dispatch('d2admin/user/set', {}, { root: true })
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     */
    load ({ commit, dispatch }) {
      return new Promise(async resolve => {
        // DB -> store 加载用户名
        await dispatch('d2admin/user/load', null, { root: true })
        // DB -> store 加载主题
        await dispatch('d2admin/theme/load', null, { root: true })
        // DB -> store 加载页面过渡效果设置
        await dispatch('d2admin/transition/load', null, { root: true })
        // DB -> store 持久化数据加载上次退出时的多页列表
        await dispatch('d2admin/page/openedLoad', null, { root: true })
        // DB -> store 持久化数据加载侧边栏折叠状态
        await dispatch('d2admin/menu/asideCollapseLoad', null, { root: true })
        await dispatch('d2admin/menu/projectCollapseLoad', null, { root: true })
        await dispatch('d2admin/menu/userCollapseLoad', null, { root: true })
        // DB -> store 持久化数据加载全局尺寸
        await dispatch('d2admin/size/load', null, { root: true })
        // common load
        await dispatch('system/common/load', null, { root: true })
        // end
        resolve()
      })
    }
  }
}
